import React, { useEffect } from 'react';
import { CloseIconDark } from 'src/assets/images';
import './modal.scss';

type ModalProps = {
  visible?: boolean;
  allowTabs?: boolean;
  size?: 'small' | 'medium' | 'large' | 'x-large' | 'custom-small' | 'extra-small';
  onClose?: () => void;
  children?: any;
  className?: string;
};

export const Modal = ({
  visible = true,
  allowTabs = false,
  size = 'large',
  onClose,
  children,
  className,
}: ModalProps) => {
  const swallowTabs = (e: KeyboardEvent) => {
    if (e.key === 'Tab') {
      return false;
    }
  };

  useEffect(() => {
    if (visible && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      if (allowTabs === false) {
        document.onkeydown = swallowTabs;
      }
    }

    document
      .getElementById('root')
      ?.setAttribute('style', visible ? 'position: fixed; width: 100%' : '');

    return () => {
      document.getElementById('root')?.setAttribute('style', '');
      document.onkeydown = () => {};
    };
  }, [visible]);

  return visible ? (
    <article className="address-modal-overlay">
      <section className={`modal-box ${size} ${className}`}>
        {onClose && <img src={CloseIconDark} alt="X" className="close-icon" onClick={onClose} />}

        <section className="scroll-box">{children}</section>
      </section>
    </article>
  ) : (
    <></>
  );
};
